import { UserAPI } from '~/http/user'
import { LocaleAPI } from '~/http/locale'
import { ZipsAPI } from '~/http/zips'
import { PropertiesAPI } from '~/http/backoffice/properties'
import { PropertyGroupsAPI } from '~/http/backoffice/property-groups'
import { PlacesAPI } from '~/http/places'

type useAPI = {
  userAPI: UserAPI
  localeAPI: LocaleAPI
  propertiesAPI: PropertiesAPI
  zipsAPI: ZipsAPI
  propertyGroupsAPI: PropertyGroupsAPI
  placesAPI: PlacesAPI
}

export const useAPI = (): useAPI => {
  return {
    userAPI: new UserAPI(),
    localeAPI: new LocaleAPI(),
    propertiesAPI: new PropertiesAPI(),
    propertyGroupsAPI: new PropertyGroupsAPI(),
    zipsAPI: new ZipsAPI(),
    placesAPI: new PlacesAPI(),
  }
}
